import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { ConfigService } from "./../../configurations/services/config.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class MyTasksService {
  constructor(private http: HttpClient, private configService: ConfigService) {}

  InsertCQCPolicy(PolicyData, complianceFileUploaded) {
    return this.http.post<any>(
      environment.configUrl +
        "/CQCFileStructure/InsertCQCPolicy?PolicyData=" +
        PolicyData +
        "&CurrentDate=" +
        new Date(),
      complianceFileUploaded
    );
  }

  insertHRComplianceData(data, complianceFileUploaded) {
    return this.http.post<any>(
      environment.configUrl +
        "HRComplience/InsertHRComplienceDetails?HRCompliencesData=" +
        data,
      complianceFileUploaded
    );
  }
  getLeaveApplications(staffID) {
    return this.http.get<any>(
      environment.configUrl +
        "/LeaveManagement/GetLeaveHistoryByStaffID?StaffID=" +
        staffID +
        "&CurrentDate=" +
        new Date()
    );
  }

  getAllHRCompliences() {
    return this.http.get<any>(
      environment.configUrl +
        "/HRComplience/GetAllHRCompliences?HRComplienceItemID=0"
    );
  }

  GetAddresses(postCode) {
    return this.http.get(
      "https://api.getAddress.io/find/" +
        postCode +
        "?api-key=" +
        environment.addresApiKey
    );
  }

  GetAllConflictSlots() {
    return this.http.get<any>(
      environment.configUrl +
        "Appointment/GetAllConflictSlots?CurrentDate=" +
        new Date()
    );
  }

  GetAppointmentDetailsForIsAppointmentCreatedOnPMS(
    IsAppointmentCreatedOnPMS,
    AppointmentScheduleSlotLevelID
  ) {
    return this.http.get<any>(
      environment.configUrl +
        "Appointment/GetAppointmentDetailsForIsAppointmentCreatedOnPMS?IsAppointmentCreatedOnPMS=" +
        IsAppointmentCreatedOnPMS +
        "&AppointmentScheduleSlotLevelID=" +
        this.configService.enc(AppointmentScheduleSlotLevelID.toString()) +
        "&CurrentDate=" +
        new Date()
    );
  }
}
